// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kzsY","colBig":"styles_colBig__1GpSs","colSmall":"styles_colSmall__3WmUB","shopifyNameWrapper":"styles_shopifyNameWrapper__35czy"};